<app-single *ngIf="type=='single'"></app-single>
<app-double *ngIf="type=='couple'"></app-double>